# import MiscellaneousActionItemResponseFragment from "../fragments/miscellaneous-action-item-response.graphql"

mutation CreateMiscellaneousActionItemResponse(
  $data: MiscellaneousActionItemResponseInput!
) {
  createMiscellaneousActionItemResponse(data: $data) {
    ...MiscellaneousActionItemResponseFragment
  }
}
